import React, { useEffect, useState } from "react";
import classNames from "classnames";
import { UIButton, UICheckBox, UIText } from "src/components/uIKit";
import styles from "./styles.module.scss";
import {
  ErrorMessage,
  FloatingLabelInput,
  Separator,
  UserInfoBanner, // dont remove
  WarningBanner,
} from "src/components";
import { useForm, Controller, FormProvider } from "react-hook-form";
import getValidationRules from "src/validations/ValidationRules";
import { useAppDispatch, useAppSelector } from "src/hooks/useRedux";
import { logPfsAnalyticsEvent, sentPostMessage } from "src/utils/utils";
import {
  API_RESULT,
  CHECKBOX_TYPE,
  TEXT_TAGS,
  INPUT_SPECIAL_TYPE,
  IDS,
  AUTOCOMPLETE,
} from "src/utils/enums";
import { setPopupInfo } from "src/redux/slices/popupSlice/popupSlice";
import { images } from "src/assets/images/images";
import { useIsDigitalOrDigitalAgent } from "src/hooks/useIsDigitalOrDigitalAgent";
import {
  GLOBAL_BLUE_PRIVACY_POLICY_LINK,
  GLOBAL_BLUE_THIRD_PARTY_LINK,
} from "src/utils/consts";
import { setThirdSectionValid } from "src/redux/slices/appSlice/AppSlice";
import { createTaxRefundMember } from "src/redux/slices/userSlice/UserApi";
import { POPUP_TYPE } from "src/utils/enums";
import { UpdateOnboardingAnalytics } from "src/utils/types";
import { useLogAnalytics } from "src/hooks/useLogAnalytics";
type FormInputs = {
  passportNumber: string;
  expirationDate: string;
  stateOfIssue: string;
  nation: string;
  enLastName: string;
  enFirstName: string;
};

type TaxRefundProps = {
  onSubmitStatus?: (status: API_RESULT) => void;
};

const TaxRefund: React.FC<TaxRefundProps> = ({ onSubmitStatus }) => {
  const { strings, fXEligibilityData, personalId, businessUnit } =
    useAppSelector((state) => state.app);
  const {
    createTaxRefundMemberResStatus,
    createTaxRefundMemberRes,
    countries,
    createTaxRefundMemberError,
  } = useAppSelector((state) => state.user);
  const dispatch = useAppDispatch();
  useLogAnalytics({ summary_global_blue: true });
  const isDigitalOrAgent = useIsDigitalOrDigitalAgent();
  const validationRules = getValidationRules(strings);
  const [taxRefundErrorMessage, setTaxRefundErrorMessage] = useState("");

  // const part1 = strings?.t_tax_refund_termsOfService;
  // const part2 = strings?.t_tax_refund_servicePricing;

  // const parts = strings.t_global_blue_checkbox_text
  //   ? strings.t_global_blue_checkbox_text.split(new RegExp(`(${part1}|${part2})`))
  //   : [];
  const parts = strings.t_global_blue_checkbox_text?.split(
    /(ספק צד שלישי|מדיניות הפרטיות והשימוש)/
  );
  const nextStepText =
    strings.t_tax_refaund_next +
    " " +
    strings.t_towards_step +
    " " +
    strings.t_benefits_accordion_title;

  const [isAcceptChecked, setIsAcceptChecked] = useState(false);

  const methods = useForm<FormInputs>({
    defaultValues: {
      passportNumber: "",
      expirationDate: "",
      stateOfIssue: "",
      nation: "",
      enLastName: "",
      enFirstName: "",
    },
  });

  useEffect(() => {
    methods.setValue("stateOfIssue", "Israel");
    methods.setValue("nation", "Israel");
  }, []);

  useEffect(() => {
    console.log("createTaxRefundMemberResStatus", createTaxRefundMemberResStatus);
    if (createTaxRefundMemberResStatus === API_RESULT.SUCCEEDED) {
      if (createTaxRefundMemberRes.responseCode == "0") {
        if (isDigitalOrAgent) {
          preperDataForPostMessage(createTaxRefundMemberResStatus, createTaxRefundMemberRes.responseCode);
        } else {
          dispatch(setThirdSectionValid(true));
        }
        onSubmitStatus?.(createTaxRefundMemberResStatus);
      } else {
        handleError(createTaxRefundMemberRes.responseCode);
      }
    } else if (createTaxRefundMemberResStatus === API_RESULT.FAILED) {
      console.log("createTaxRefundMemberError==>", createTaxRefundMemberError.data.responseCode);
      handleError(createTaxRefundMemberError.data.responseCode);
    }
  }, [createTaxRefundMemberResStatus]);

  const handleError = (responseCode: string) => {
    if (isDigitalOrAgent) {
      preperDataForPostMessage(API_RESULT.FAILED, responseCode);
    } else {
      dispatch(setThirdSectionValid(false));
    }
    onSubmitStatus?.(createTaxRefundMemberResStatus);
    dispatch(setThirdSectionValid(true));
    // setTaxRefundErrorMessage(getTaxRefundErrorMessage(responseCode));
  

  };

  // const getTaxRefundErrorMessage = (responseCode: any) => {
  //   console.log("responseCode==>", responseCode);
    
  //   switch (responseCode) {
  //     case 1:
  //       return strings.t_tax_refund_RC_1;
  //     case 2:
  //       return strings.t_tax_refund_RC_2;
  //     case 3:
  //       return strings.t_tax_refund_RC_3;

  //     default:
  //       return strings.t_tax_refaund_general_error_message;
  //   }
  // };

  const preperDataForPostMessage = (resStatus: API_RESULT, responseCode: string) => {
    const info = {
      status: resStatus,
      collectCardInstruction: fXEligibilityData.collectCardInstruction,
      passportCard4LastDigits: fXEligibilityData.passportCard4LastDigits,
      responseCode: responseCode,
    };
    sentPostMessage(info);
  };

  const onSubmit = (data: any) => {
    setTaxRefundErrorMessage("");
    // check if data is valid
    dispatch(
      createTaxRefundMember({
        feCustPassportNum: data.passportNumber,
        feIssuingCountry: data.stateOfIssue,
        feCustLastNameEnglish: data.enLastName,
        feCustPassportNationality: data.nation,
        feCustPersId: personalId,
        feCustPassportValidity: data.expirationDate,
        feBU: businessUnit,
        feCustFirstNameEnglish: data.enFirstName,
      })
    );
  };

  const handleAcceptCheckboxChange = () => {
    setIsAcceptChecked(!isAcceptChecked);
  };

  // const renderPolicyText = (
  //   parts: string[]
  // ): (string | React.ReactElement)[] => {
  //   return parts?.map((part, index) => {
  //     if (part === part1) {
  //       return (
  //         <a
  //           aria-label={strings.acc_t_tax_refaund_3rd_party_policy_text}
  //           key={index}
  //           href={GLOBAL_BLUE_THIRD_PARTY_LINK}
  //           target="_blank"
  //           rel="noopener noreferrer"
  //         >
  //           {part}
  //         </a>
  //       );
  //     }
  //     if (part === part2) {
  //       return (
  //         <a
  //           aria-label={strings.acc_t_tax_refaund_policy_text}
  //           key={index}
  //           href={GLOBAL_BLUE_PRIVACY_POLICY_LINK}
  //           target="_blank"
  //           rel="noopener noreferrer"
  //         >
  //           {part}
  //         </a>
  //       );
  //     }
  //     return part; // Render normal text
  //   });
  // };
  const renderPolicyText = (): (string | React.ReactElement)[] => {
    return parts?.map((part, index) => {
      if (part === "ספק צד שלישי") {
        return (
          <a
            key={index}
            href={GLOBAL_BLUE_THIRD_PARTY_LINK}
            target="_blank"
            rel="noopener noreferrer"
          >
            {part}
          </a>
        );
      }
      if (part === "מדיניות הפרטיות והשימוש") {
        return (
          <a
            key={index}
            href={GLOBAL_BLUE_PRIVACY_POLICY_LINK}
            target="_blank"
            rel="noopener noreferrer"
          >
            {part}
          </a>
        );
      }
      return part; // Render normal text
    });
  };

  const renderPolicyTextAriaLabel = (): string => {
    return renderPolicyText()
      .map((v) => {
        if (React.isValidElement<{ "aria-label"?: string }>(v)) {
          return v.props["aria-label"] || "";
        }
        return v;
      })
      .join(" ");
  };
  return (
    <FormProvider {...methods}>
      <div className={styles.container}>
        <UIText
          text={strings.t_tax_refaund_how_it_works}
          tag={TEXT_TAGS.H3}
          size={20}
          weight={500}
          style={styles.mBottom}
        />
        <UIText
          text={strings.t_tax_refaund_title}
          size={18}
          weight={400}
          style={styles.sectionTitle}
        />
        <br />
        {/* <br /> */}
        <WarningBanner 
          title={""}
          subTitle={strings.t_tax_refaund_yellow_banner_title}
        />

        <Separator />

        <fieldset>
          <legend className="srOnly">
            {strings.t_tax_refaund_info_to_register}
          </legend>
          <div className={isDigitalOrAgent ? styles.iframeRow : styles.row}>
            <Controller
              name="passportNumber"
              rules={validationRules.passportNumber}
              render={({ field, fieldState: { error } }) => (
                <div className={styles.flexColumn}>
                  <FloatingLabelInput
                    label={strings.t_tax_refaund_info_passport_number}
                    ariaLabel={strings.acc_t_tax_refaund_info_passport_number}
                    {...field}
                    style={styles.mBottom0}
                    {...(error
                      ? {
                          errorDescribedBy:
                            IDS.TAX_REFAUND_PASSPORT_NUMBER_ERROR_MESSAGE,
                        }
                      : {})}
                  />
                  <ErrorMessage
                    ariaLabel={
                      "שגיאה בשדה " +
                      strings.acc_t_tax_refaund_info_passport_number +
                      " " +
                      error?.message
                    }
                    id={IDS.TAX_REFAUND_PASSPORT_NUMBER_ERROR_MESSAGE}
                    style={styles.errorStyleZip}
                    message={error?.message}
                  />
                </div>
              )}
            />

            <Controller
              name="nation"
              rules={validationRules.nation}
              render={({ field, fieldState: { error } }) => (
                <div className={styles.flexColumn}>
                  <FloatingLabelInput
                    label={strings.t_tax_refaund_nation}
                    ariaLabel={strings.acc_t_tax_refaund_nation}
                    {...field}
                    style={classNames(styles.mRight, styles.mBottom0)}
                    autoCompleteType={AUTOCOMPLETE.NATIONALITY}
                    countriesResults={countries.map((country) => ({
                      value: country,
                      label: country,
                    }))}
                    {...(error
                      ? {
                          errorDescribedBy:
                            IDS.TAX_REFAUND_NATION_ERROR_MESSAGE,
                        }
                      : {})}
                  />

                  <ErrorMessage
                    ariaLabel={
                      "שגיאה בשדה " +
                      strings.acc_t_tax_refaund_nation +
                      " " +
                      error?.message
                    }
                    id={IDS.TAX_REFAUND_NATION_ERROR_MESSAGE}
                    style={styles.errorStyleZip}
                    message={error?.message}
                  />
                </div>
              )}
            />
          </div>

          <div className={isDigitalOrAgent ? styles.iframeRow : styles.row}>
            <Controller
              name="enLastName"
              rules={validationRules.lastName}
              render={({ field, fieldState: { error } }) => (
                <div className={styles.flexColumn}>
                  <FloatingLabelInput
                    label={strings.t_login_last_name}
                    ariaLabel={strings.acc_t_login_last_name}
                    {...field}
                    style={styles.mBottom0}
                    {...(error
                      ? {
                          errorDescribedBy:
                            IDS.TAX_REFAUND_EN_LAST_NAME_ERROR_MESSAGE,
                        }
                      : {})}
                  />
                  <ErrorMessage
                    ariaLabel={
                      "שגיאה בשדה " +
                      strings.acc_t_login_last_name +
                      " " +
                      error?.message
                    }
                    id={IDS.TAX_REFAUND_EN_LAST_NAME_ERROR_MESSAGE}
                    style={styles.errorStyleZip}
                    message={error?.message}
                  />
                </div>
              )}
            />
            <Controller
              name="enFirstName"
              rules={validationRules.firstName}
              render={({ field, fieldState: { error } }) => (
                <div className={styles.flexColumn}>
                  <FloatingLabelInput
                    label={strings.t_login_first_name}
                    ariaLabel={strings.acc_t_login_first_name}
                    {...field}
                    style={classNames(styles.mRight, styles.mBottom0)}
                    {...(error
                      ? {
                          errorDescribedBy:
                            IDS.TAX_REFAUND_EN_FIRST_NAME_ERROR_MESSAGE,
                        }
                      : {})}
                  />
                  <ErrorMessage
                    ariaLabel={
                      "שגיאה בשדה " +
                      strings.acc_t_login_first_name +
                      " " +
                      error?.message
                    }
                    id={IDS.TAX_REFAUND_EN_FIRST_NAME_ERROR_MESSAGE}
                    style={styles.errorStyleZip}
                    message={error?.message}
                  />
                </div>
              )}
            />
          </div>

          <div className={isDigitalOrAgent ? styles.iframeRow : styles.row}>
            <Controller
              name="expirationDate"
              rules={validationRules.experationDate}
              render={({ field, fieldState: { error } }) => (
                <div className={styles.flexColumn}>
                  <FloatingLabelInput
                    label={strings.t_tax_refaund_expiration_date_text_aria}
                    ariaLabel={
                      strings.acc_t_tax_refaund_expiration_date_text_aria
                    }
                    {...field}
                    style={styles.mBottom0}
                    inputType={INPUT_SPECIAL_TYPE.DATE}
                    {...(error
                      ? {
                          errorDescribedBy:
                            IDS.TAX_REFAUND_EXPIRATION_DATE_ERROR_MESSAGE,
                        }
                      : {})}
                  />
                  <ErrorMessage
                    ariaLabel={
                      "שגיאה בשדה " +
                      strings.acc_t_tax_refaund_expiration_date_text_aria +
                      " " +
                      error?.message
                    }
                    id={IDS.TAX_REFAUND_EXPIRATION_DATE_ERROR_MESSAGE}
                    style={styles.errorStyleZip}
                    message={error?.message}
                  />
                </div>
              )}
            />
            <Controller
              name="stateOfIssue"
              rules={validationRules.stateOfIssue}
              render={({ field, fieldState: { error } }) => (
                <div className={styles.flexColumn}>
                  <FloatingLabelInput
                    label={strings.t_tax_refaund_state_of_issue}
                    ariaLabel={strings.acc_t_tax_refaund_state_of_issue}
                    {...field}
                    style={classNames(styles.mRight, styles.mBottom0)}
                    autoCompleteType={AUTOCOMPLETE.NATIONALITY}
                    countriesResults={countries.map((country) => ({
                      value: country,
                      label: country,
                    }))}
                    {...(error
                      ? {
                          errorDescribedBy:
                            IDS.TAX_REFAUND_STATE_OF_ISSUE_ERROR_MESSAGE,
                        }
                      : {})}
                  />
                  <ErrorMessage
                    ariaLabel={
                      "שגיאה בשדה " +
                      strings.acc_t_tax_refaund_state_of_issue +
                      " " +
                      error?.message
                    }
                    id={IDS.TAX_REFAUND_STATE_OF_ISSUE_ERROR_MESSAGE}
                    style={styles.errorStyleZip}
                    message={error?.message}
                  />
                </div>
              )}
            />
          </div>
        </fieldset>
        <div></div>
        <Separator />
        <div
          className={classNames(styles.mTop, styles.checkBoxWrapper)}
          // onClick={handleMoveWithoutSubmit}
        >
          <>
            <UICheckBox
              checked={isAcceptChecked}
              onChange={handleAcceptCheckboxChange}
              type={CHECKBOX_TYPE.SQUARE}
            />
            <UIText
              tabIndex={0}
              ariaLabel={renderPolicyTextAriaLabel()}
              // text={renderPolicyText()}
              text={strings.t_global_blue_checkbox_text}
              size={18}
              weight={400}
            />
          </>
        </div>
        <section>
          {/* Dont remove , show this message only if server returns error */}
          <ErrorMessage message={taxRefundErrorMessage} />

          <div className={styles.buttonWrapepr}>
            <UIButton
              title={strings.t_tax_refaund_next}
              ariaLabel={nextStepText}
              onSubmit={methods.handleSubmit(onSubmit)}
              disabled={
                !isAcceptChecked ||
                createTaxRefundMemberResStatus === API_RESULT.LOADING
              }
              isLoading={createTaxRefundMemberResStatus === API_RESULT.LOADING}
            />
          </div>
        </section>
      </div>
    </FormProvider>
  );
};

export default TaxRefund;
